<style scoped lang="scss" type="text/scss">
.recommendation-container {
    .submit-buttons {
        margin-top: 1rem;
    }
}
</style>

<template>
    <div class="recommendation-container">
        <block-divider>宣传员</block-divider>
        <current-registrable-managed-player-members-selector
            v-model="propagandistIds" placeholder="请选择"
        >
        </current-registrable-managed-player-members-selector>

        <div class="submit-buttons">
            <el-button type="primary" plain @click="update()" :loading="requesting">保存</el-button>
            <el-button @click="reset()">重置</el-button>
        </div>
    </div>
</template>

<script>
import BlockDivider from '../../../../../components/divider/block';
import CurrentRegistrableManagedPlayerMembersSelector
    from '../../../../sub-components/current-registrable-managed-player-members-selector/index';
import {mapState} from 'vuex';
import _ from 'lodash';

export default {
    name: '',
    components: {
        BlockDivider,
        CurrentRegistrableManagedPlayerMembersSelector
    },
    data () {
        return {
            propagandistIds: [],
            requesting: false
        };
    },
    computed: {
        ...mapState('player', {
            currentManagedPlayerId: state => state.currentManagedPlayerId,
            currentManagedPlayerPropagandist: state => state.currentManagedPlayerPropagandist,
            currentManagedPlayerPropagandistIds: state => state.currentManagedPlayerPropagandistIds,
        })
    },
    watch: {
        currentManagedPlayerId: {
            immediate: true,
            handler (currentManagedPlayerId) {
                if (currentManagedPlayerId === null || currentManagedPlayerId === undefined) return;
                this.loadMembers();
                this.loadPropagandist();
            }
        },
        currentManagedPlayerPropagandist: {
            immediate: true,
            handler () {
                this.resetVariables();
            }
        }
    },
    methods: {
        update () {
            if (this.propagandistIds.length === 0) {
                this.$tip('请推荐至少一名宣传员');
                return;
            }

            const params = {
                id: this.currentManagedPlayerId,
                propagandist: this.propagandistIds,
            };
            this.$normalRequest('player/assignPropagandist', params, '宣传员信息保存成功', true, this, 'requesting').then(_ => {
                this.loadPropagandist();
            }).catch(_ => {
            });
        },
        reset () {
            this.loadPropagandist();
        },
        loadPropagandist () {
            this.$store.dispatch('player/loadPropagandist', {
                id: this.currentManagedPlayerId
            }).then(response => {
            });
        },
        loadMembers () {
            this.$store.dispatch('player/loadMembers', {
                id: this.currentManagedPlayerId
            }).then();
        },
        resetVariables () {
            this.propagandistIds = _.cloneDeep(this.currentManagedPlayerPropagandistIds);
        }
    }
};
</script>
